export enum ProviderChartTypeEnum {
	Language = 'Language',
	Service = 'Service',
}

export const ProviderChartTypeArray = [
    ProviderChartTypeEnum.Language,
    ProviderChartTypeEnum.Service,
];

